import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  addWinnerList,
  getLeaderBoardList,
} from "../../../features/slices/challanges";
import { useDispatch } from "react-redux";
import CommonPagination from "../../CommonPagination";
import { useSelector } from "react-redux";
import TableSkeleton from "../../TableSkeleton";
import ExportToExcel from "../../ExportToExcel";
import { toastService } from "../../../utils/toastify";
import { canPerformAction } from "../../../utils/denyAccess";
import Silver from "../../../assets/images/Silver.png"
import Platinum from "../../../assets/images/Platinum.png"
import Gold from "../../../assets/images/Gold.png"
import Bronze from "../../../assets/images/Bronze.png"

const initialState = {
  fromDate: "",
  toDate: "",
  timeframe: "",
  searchQuery: "",
  category: "",
};
const Leaderboard = () => {
  const [iState, setUpdateState] = useState(initialState);
  const { searchQuery, fromDate, toDate, timeframe, category } = iState;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  const { leaderboard, loading } = useSelector((state) => {
    return state.challenges;
  });
  console.log(leaderboard, "leaderboard")
  const leaderBoardRef = useRef();
  const handleSubmit = () => {
    const queryParams = {
      page: 1,
    };
    if (fromDate && toDate) {
      queryParams.startDate = fromDate;
      queryParams.endDate = toDate;
    } else if (timeframe) {
      queryParams.timeframe = timeframe;
    }

    dispatch(getLeaderBoardList(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
      }
    });
  };
  const handleTimeFrame = (e) => {
    const queryParams = {
      timeframe: e.target.value,
    };
    setUpdateState((prev) => ({
      ...prev,
      timeframe: e.target.value,
    }));
    dispatch(getLeaderBoardList(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
        // setUpdateState((prev) => ({
        //   ...prev,
        //   timeframe: "",
        // }));
      }
    });
  };
  const handleReset = () => {
    setUpdateState(initialState);
    dispatch(getLeaderBoardList({ page }));
  };
  useEffect(() => {
    dispatch(getLeaderBoardList({ page }));
  }, [page]);
  useEffect(() => {
    if (searchQuery.trim() !== "") {
      const delayDebounceFunc = setTimeout(() => {
        dispatch(getLeaderBoardList({ search: searchQuery })).then((res) => {
          if (res?.payload?.code == 200) {
            // setUpdateState((prev) => ({
            //   ...prev,
            //   searchQuery: "",
            // }));
          }
        });
      }, 1000);
      return () => clearTimeout(delayDebounceFunc);
    }
  }, [searchQuery, dispatch]);
  const handleSearch = (e) => {
    const { name, value } = e.target;
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeCategory = (e) => {
    dispatch(
      getLeaderBoardList({
        categoryId: e.target.value,
      })
    );
  };
  const handleAddToWinnerList = (id) => {
    const data = {
      userId: id,
    };
    dispatch(addWinnerList(data)).then((res) => {
      if (res?.payload?.code == 200) {
        toastService.success("Winner  added successfully");
        navigate("leaderboardAddWinnerList", { state: id });
      } else {
        toastService.error("Failed to add winner");
      }
    });
  };
  return (
    <div className="tab-pane fade active show" id="Leaderboard">
      <div className="FilterArea">
        <div className="FilterLeft">
          <div className="form-group">
            <label>From Date</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              disabled={timeframe}
              name="fromDate"
              onChange={(e) => handleSearch(e)}
            />
          </div>
          <div className="form-group">
            <label>To Date</label>
            <input
              type="date"
              className="form-control"
              name="toDate"
              value={toDate}
              disabled={timeframe}
              onChange={(e) => handleSearch(e)}
            />
          </div>
          <div className="form-group">
            <label>&nbsp;</label>
            <button className="Button" onClick={handleSubmit}>
              Apply
            </button>
          </div>
          <div className="form-group">
            <label>Timeframe</label>
            <select
              className="form-control customSelect"
              name="timeframe"
              value={timeframe}
              disabled={fromDate || toDate}
              onChange={(e) => handleTimeFrame(e)}
            >
              <option value="" hidden>
                Select
              </option>
              <option value="Today">Today</option>
              <option value="Week">This Week</option>
              <option value="Month">This Month</option>
            </select>
          </div>
        </div>
      </div>
      <div className="NewFilter">
        <div className="SearchBox">
          <input
            type="search"
            className="SearchInput"
            placeholder="Search here by ID, Name, or Others"
            name="searchQuery"
            value={searchQuery}
            onChange={(e) => handleSearch(e)}
          />
          <span>
            <i className="fa fa-search" />
          </span>
        </div>
        <div className="Actions">
          <div
            className="form-group"
            style={{
              textAlign: "center",
            }}
          >
            <button className="FilterBtn">
              <span>
                <img src={require("../../../assets/images/filter.png")} />
              </span>
              Filters
            </button>
          </div>
          <button className="Button Cancel" onClick={handleReset}>
            <i className="fa fa-refresh" />
          </button>
          <ExportToExcel
            ref={leaderBoardRef}
            fileName="leaderboardChallangesData"
          />
        </div>
      </div>
      <div className="TableList">
        <table className="table-hover" ref={leaderBoardRef}>
          <thead>
            <tr>
              <th>Sr. No</th>
              <th>Student Id</th>
              <th>Student Name</th>
              <th>No. of Challange</th>
              <th>Total Points Earned</th>
              <th>Rank</th>
              {canPerformAction("Challenges&Bounty") && (
                <th>Badges</th>
              )}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <TableSkeleton />
            ) : (
              leaderboard?.result?.paginationData?.map((res, i) => {
                return (
                  <tr key={res?._id}>
                    <td>{i + 1 + (page - 1) * 10}</td>
                    <td>{res?.user_number}</td>
                    <td>{res?.fullName}</td>
                    <td>{res?.attendCount}</td>
                    <td>{res?.totalPoints}</td>
                    <td>{res?.rank}</td>
                    {/* {canPerformAction("Challenges&Bounty") && (
                      <td>
                        <div className="Actions">
                          <a
                            className="Black ml-0"
                            onClick={() => handleAddToWinnerList(res?._id)}
                          >
                            Add to Winners List
                          </a>
                        </div>
                      </td>
                    )} */}
                    <td>
                      <img src={res?.tier == "GOLD" ? Gold : res?.tier == "SILVER" ? Silver : res?.tier == "PLATINUM" ? Platinum : Bronze} />
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
      <div className="Pagination">
        {leaderboard?.result?.totalCount?.[0]?.count > 0 && (
          <>
            <p>
              Showing {(page - 1) * 10 + 1} to{" "}
              {leaderboard?.result?.paginationData?.length +
                (page - 1) * 10}{" "}
              of {leaderboard?.result?.totalCount?.[0]?.count} results
            </p>
            <div className="PaginationRight">
              {leaderboard?.result?.totalCount?.[0]?.count > 0 && (
                <CommonPagination
                  activePage={page}
                  itemsCountPerPage={10}
                  totalItemsCount={
                    leaderboard?.result?.totalCount?.[0]?.count || 0
                  }
                  pageRangeDisplayed={4}
                  onChange={handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Leaderboard;
